export const getDollars = (cents: number): string =>
  `$${(cents / 100).toFixed(2)}`;

export const numStringToCents = (numString: string): number =>
  parseFloat(parseFloat(numString).toFixed(2)) * 100;

export const formatCurrencyString = (
  {
    value,
    currency
  }: {
    value: number;
    currency: string;
  },
  renderDollar = true
) => {
  const language = currency === 'CAD' ? 'en-CA' : 'en-US';

  const numberFormat = new Intl.NumberFormat(language, {
    style: 'currency',
    currency,
    currencyDisplay: 'symbol',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  });
  const parts = numberFormat.formatToParts(value);
  let zeroDecimalCurrency = true;

  for (let i = 0; i < parts.length; i += 1) {
    const part = parts[i];
    if (part.type === 'decimal') {
      zeroDecimalCurrency = false;
      break;
    }
  }

  let val = zeroDecimalCurrency ? value : value / 100;

  if (!renderDollar) {
    return numberFormat
      .format(parseFloat(val.toFixed(2)))
      .replace(/\D00(?=\D*$)/, '')
      .replace('$', '');
  }

  return numberFormat
    .format(parseFloat(val.toFixed(2)))
    .replace(/\D00(?=\D*$)/, '');
};
